export class Debounce {
  constructor (time) {
    this.time = time

    this.timeoutId = -1
  }

  run (action) {
    clearTimeout(this.timeoutId)
    this.timeoutId = -1

    this.timeoutId = setTimeout(() => {
      action()
    }, this.time)
  }
}
